/* THE GODDESS · theme.js · vanilla, geen dependencies */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };
  const root = (T.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money ---------- */
  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '€{{amount_with_comma_separator}}';
    const v = (cents / 100);
    const withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const noDecimals = Math.round(v).toString();
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (msg) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };

  /* ---------- Drawers (menu, cart, filters) ---------- */
  let lastFocus = null;
  const openDrawer = (drawer) => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = drawer.querySelector('button, a, input, select, textarea');
    setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 50);
  };
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-drawer].is-open').forEach(closeDrawer);
    closeSearch();
    closeMega();
  });

  /* ---------- Header: sticky state + mega menu ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  const navItems = $$('[data-nav-item]');
  let megaTimer;
  const closeMega = () => navItems.forEach((n) => { n.classList.remove('is-open'); const a = n.querySelector('.nav-link'); a && a.setAttribute('aria-expanded', 'false'); });
  navItems.forEach((item) => {
    const link = item.querySelector('.nav-link');
    const open = () => { clearTimeout(megaTimer); closeMega(); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); };
    const close = () => { megaTimer = setTimeout(() => { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 120); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    link.addEventListener('click', (e) => {
      // Touch-apparaten met brede schermen: eerste tik opent het menu
      if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
  });

  /* ---------- Announcement rotation (mobiel) ---------- */
  const ann = $('[data-announcement]');
  if (ann) {
    const items = $$('.announcement__item', ann);
    if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let i = 0;
      setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4200);
    }
  }

  /* ---------- Search ---------- */
  const searchModal = $('[data-search-modal]');
  const openSearch = () => {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    setTimeout(() => { const i = $('[data-predictive-input]'); i && i.focus(); }, 60);
  };
  function closeSearch() {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  const pInput = $('[data-predictive-input]');
  const pResults = $('[data-predictive-results]');
  if (pInput && pResults) {
    const initial = pResults.innerHTML;
    let ctrl, timer;
    pInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = initial; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article,query&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`;
          const res = await fetch(url, { signal: ctrl.signal });
          if (!res.ok) return;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('.shopify-section') || doc.body;
          pResults.innerHTML = section.innerHTML;
        } catch (err) { /* afgebroken of offline */ }
      }, 220);
    });
  }

  /* ---------- Cart ---------- */
  const cartSections = ['cart-drawer', 'cart-icon-bubble'];
  const renderSections = (sections) => {
    if (!sections) return;
    if (sections['cart-icon-bubble']) {
      const bubble = $('#cart-icon-bubble');
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section');
      if (bubble && inner) bubble.innerHTML = inner.innerHTML;
    }
    if (sections['cart-drawer']) {
      const wrap = document.getElementById('shopify-section-cart-drawer');
      const wasOpen = $('#CartDrawer')?.classList.contains('is-open');
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const inner = doc.querySelector('.shopify-section');
      if (wrap && inner) {
        wrap.innerHTML = inner.innerHTML;
        const d = $('#CartDrawer');
        if (wasOpen && d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
      }
    }
  };
  const isCartPage = document.body.classList.contains('template-cart');
  const openCart = () => {
    if (isCartPage || settingsCartType() === 'page') { window.location.href = T.routes.cart; return; }
    openDrawer($('#CartDrawer'));
  };
  function settingsCartType() { return document.documentElement.dataset.cartType || 'drawer'; }

  document.addEventListener('click', (e) => {
    const cartOpener = e.target.closest('[data-cart-open]');
    if (cartOpener && !isCartPage) { e.preventDefault(); openCart(); }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form], form.product-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]') || document.querySelector(`[form="${form.id}"][type="submit"]`);
    const errEl = form.querySelector('[data-form-error]');
    if (errEl) errEl.hidden = true;
    btn && btn.classList.add('is-loading');
    const fd = new FormData(form);
    fd.append('sections', cartSections.join(','));
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) {
        const msg = data.description || data.message || T.strings.error;
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else { toast(msg); }
        return;
      }
      renderSections(data.sections);
      if (isCartPage) { window.location.reload(); return; }
      openCart();
    } catch (err) {
      toast(T.strings.error);
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  });

  const changeLine = async (key, quantity) => {
    const drawer = $('#CartDrawer');
    drawer && drawer.querySelector('.drawer__panel')?.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: cartSections, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) { toast(data.description || T.strings.error); return; }
      if (isCartPage) { window.location.reload(); return; }
      renderSections(data.sections);
    } catch (err) { toast(T.strings.error); }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.dataset.key, Math.max(0, parseInt(b.dataset.qtyChange, 10) || 0));
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-qty-input]');
    if (!i) return;
    changeLine(i.dataset.key, Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* ---------- Quantity stepper (productpagina) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('[data-qty]');
    if (!input) return;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    input.value = next;
  });

  /* ---------- Product: varianten, galerij, sticky ATC ---------- */
  $$('[data-product-section]').forEach((section) => {
    const sectionId = section.dataset.section;
    const jsonEl = section.parentElement.querySelector('[data-variants]');
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const form = section.querySelector('form.product-form');
    const idInput = form && form.querySelector('[data-variant-id]');
    const addBtn = form && form.querySelector('[data-add-button]');
    const addLabel = addBtn && addBtn.querySelector('[data-add-label]');
    const priceWrap = document.getElementById(`Price-${sectionId}`);
    const stock = section.querySelector('[data-stock]');
    const gallery = section.querySelector('[data-gallery]');
    const dots = section.querySelector('[data-gallery-dots]');
    const sticky = section.parentElement.querySelector('[data-sticky-atc]');
    const stickyBtn = sticky && sticky.querySelector('[data-sticky-add]');
    const stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');

    const priceHTML = (v) => {
      const sale = v.compare > v.price;
      return `<div class="price${sale ? ' price--sale' : ''}" data-price>${sale ? `<s>${formatMoney(v.compare)}</s>` : ''}<span class="price__current">${formatMoney(v.price)}</span></div>`;
    };

    const scrollToMedia = (mediaId) => {
      if (!gallery || !mediaId) return;
      const item = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!item) return;
      if (window.matchMedia('(max-width: 749px)').matches) {
        gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else if (item !== gallery.firstElementChild) {
        gallery.prepend(item);
      }
    };

    const update = () => {
      const selected = $$('[data-variant-picker] input:checked', section).map((i) => i.value);
      const v = variants.find((x) => x.options.every((o, idx) => o === selected[idx]));
      $$('[data-option-label]', section).forEach((l) => { l.textContent = selected[+l.dataset.optionLabel] || ''; });
      // beschikbaarheid per optiewaarde (op basis van de andere gekozen opties)
      $$('[data-variant-picker] input', section).forEach((input) => {
        const idx = +input.dataset.optionIndex;
        const test = selected.slice(); test[idx] = input.value;
        const match = variants.find((x) => x.options.every((o, i) => o === test[i]));
        input.classList.toggle('is-unavailable', !match || !match.available);
      });
      if (!v) {
        addBtn && (addBtn.disabled = true);
        addLabel && (addLabel.textContent = T.strings.unavailable);
        stickyBtn && (stickyBtn.disabled = true);
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (priceWrap) { const p = priceWrap.querySelector('[data-price]'); if (p) p.outerHTML = priceHTML(v); }
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v);
      if (stock) {
        stock.classList.remove('stock--low', 'stock--out');
        if (!v.available) { stock.classList.add('stock--out'); stock.textContent = T.strings.soldOut; }
        else if (v.tracked && v.policy === 'deny' && v.inv > 0 && v.inv < 5) { stock.classList.add('stock--low'); stock.textContent = stock.dataset.lowTemplate.replace('__N__', v.inv); }
        else { stock.textContent = stock.dataset.inStock; }
      }
      scrollToMedia(v.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    section.addEventListener('change', (e) => { if (e.target.closest('[data-variant-picker]')) update(); });

    // Galerij-dots (mobiel)
    if (gallery && dots) {
      const buttons = $$('button', dots);
      buttons.forEach((b, i) => b.addEventListener('click', () => gallery.scrollTo({ left: gallery.children[i].offsetLeft, behavior: 'smooth' })));
      let raf;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          buttons.forEach((b, j) => b.setAttribute('aria-current', j === i ? 'true' : 'false'));
        });
      }, { passive: true });
    }

    // Sticky koopbalk
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn && (stickyBtn.tabIndex = show ? 0 : -1);
      });
      io.observe(addBtn);
    }
  });

  /* ---------- Productaanbevelingen ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length && el.querySelector('.product-grid')) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else el.remove();
    } catch (err) { /* stil falen */ }
  });

  /* ---------- Collectie: sorteren + filters ---------- */
  const sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  const filterForm = $('[data-filter-form]');
  if (filterForm && window.matchMedia('(min-width: 990px)').matches) {
    filterForm.addEventListener('change', (e) => { if (e.target.type === 'checkbox') filterForm.requestSubmit(); });
  }

  /* ---------- Artikel: leesvoortgang, inhoudsopgave, link kopiëren ---------- */
  const postBody = $('[data-post-body]');
  if (postBody) {
    const bar = $('[data-post-progress] span');
    const onScroll = () => {
      const r = postBody.getBoundingClientRect();
      const total = r.height - window.innerHeight * 0.6;
      const p = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    const links = $$('[data-post-toc] a');
    if (links.length && 'IntersectionObserver' in window) {
      const map = new Map(links.map((a) => [decodeURIComponent(a.hash.slice(1)), a]));
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          links.forEach((a) => a.classList.remove('is-active'));
          const a = map.get(e.target.id);
          if (a) a.classList.add('is-active');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      $$('h2[id]', postBody).forEach((h) => io.observe(h));
    }
    $$('.post-toc--mobile a').forEach((a) => a.addEventListener('click', () => { a.closest('details').open = false; }));
    $$('[data-copy-link]').forEach((btn) => btn.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(btn.dataset.copyLink); const t = btn.textContent; btn.textContent = btn.dataset.copied; setTimeout(() => { btn.textContent = t; }, 1800); } catch (err) { /* stil falen */ }
    }));
  }
})();
